export const styles = {
  dots: {
    display: 'grid',
    gridTemplateColumns: 'repeat(10, auto)',
    width: { xs: 100, sm: 150 },
    height: { xs: 100, sm: 150 },
  },
  dot: { width: 5, height: 5, borderRadius: '50%', bgcolor: '#ffffff81' },
};
